module.exports = __webpack_public_path__ + "media/images/athletes/990-ad2bde01afd3fc99766d7390788bf3e0.png";